import "./styles.scss";
import React from "react";
import { connect } from "react-redux";
import { navigationIds } from "../../../analyticsTags";
import { RootState } from "../../../reducers";
import { loadPageData } from "../../../actions/cms";
let dropdown_view = false;
let _profile: any;
const WatchJoin: React.FC<any> = ({
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  joinData,
  loginData,
  isMobile,
}) => {
  if (profile !== undefined) {
    _profile = profile;
  }

  let dropdownClass = isMobile ? 'dropdown-user-options-mobile' : 'dropdown-user-options';

  return (
    <>
      {isLoggedIn ? (
        <>
          <p className="user-name">
            Hello, {_profile ? _profile.firstName : "test"}
          </p>{" "}
          <span/>{" "}
          <a
            className={"user-spin-id"}
            id={navigationIds.navigationLogout}
            href="/"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              dropdown_view = !dropdown_view;
              console.log('isMobile', isMobile);
              if (dropdown_view) {

                if (isMobile) {
                  document
                    .getElementsByClassName("dropdown-user-options-mobile")[0]
                    .classList.add("dropdown-block");
                }
                else {
                  document
                    .getElementsByClassName("dropdown-user-options")[0]
                    .classList.add("dropdown-block");
                }

              } else {
                if (isMobile) {
                  document
                    .getElementsByClassName("dropdown-user-options-mobile")[0]
                    .classList.remove("dropdown-block");
                }
                else {
                  document
                    .getElementsByClassName("dropdown-user-options")[0]
                    .classList.remove("dropdown-block");
                }
              }
            }}
          >
            <p className="user-spin-id">
              SPIN ID <samp>{_profile ? _profile.spinID : ""}</samp>
            </p>
          </a>
          <div className={dropdownClass}>
            <div className="spin-id-check">
              <p className="my-spin-id">Did My SPIN ID Win?</p>
              <a href={window.location.origin + "/wheel-watchers/my-spin-id"}>Check</a>
            </div>

            <div className="content">
              <div>
                <div className="gigya-raas">
                  <span
                    className="gigya-raas"
                    style={{ display: "inline" }}
                  />
                  <span
                    className="gigya-raas"
                    style={{ display: "inline" }}
                  />
                  <span className="gigya-raas">
                    <a href="/wheel-watchers/edit-profile">Profile</a>
                    or
                    <a
                      href="/react/logout"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onLogOut();
                      }}
                    >
                      Log Out
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <p>Wheel Watchers Club SPIN ID </p>
          <a
            id={navigationIds.navigationLogin}
            href="/"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onLogIn();
            }}
          >
            {loginData ? loginData.login_link_text : "Log In"}
          </a>{" "}
          or{" "}
          <a
            id={navigationIds.navigationJoin}
            href={
              window.location.origin + (joinData ? joinData.join_link : "/wheel-watchers/register")
            }
          >
            {joinData ? joinData.join_link_text : "Join Now"}
          </a>
        </>
      )}
    </>
  );
};

export const JoinWheelWatchers: React.FC<any> = ({
  joinHtml = "",
  isMobile,
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  joinData,
  loginData,
}) => {
  return (
    <div
      className={
        isLoggedIn
          ? "user-login"
          : ""
      }
    >
      <WatchJoin
        onJoin={onJoin}
        onLogIn={onLogIn}
        isLoggedIn={isLoggedIn}
        onLogOut={onLogOut}
        profile={profile}
        loginData={loginData}
        joinData={joinData}
        isMobile={isMobile}
      />
    </div>
  );
};

const HeaderTopBar: React.FC<any> = ({
  joinHtml = "",
  onJoin,
  onLogIn,
  onLogOut,
  isLoggedIn,
  profile,
  loginData,
  joinData,
  isMobile,
}) => {
  return (
        <div >

          <JoinWheelWatchers
            joinHtml={joinHtml}
            onJoin={onJoin}
            onLogIn={onLogIn}
            isMobile={isMobile}
            isLoggedIn={isLoggedIn}
            onLogOut={onLogOut}
            profile={profile}
            loginData={loginData}
            joinData={joinData}
          />

        </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchSiteData: () => dispatch(loadPageData()),
});

const mapStateToProps = (state: RootState) => ({
  header: state.site.header,
  isLoggedIn: state.auth.isLoggedIn,
  profile: state.auth.profile,
});

HeaderTopBar.defaultProps = {
  fetchSiteData: () => {},
  header: {},
};

export { HeaderTopBar };

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTopBar);
